import { validateEmail, validatePwd, validateUrl } from '~/utils/validator'
import { TeaMap } from '~/const/teaEvents'
import { customReportTTPixel } from '~/utils/reportTT'
import { EFormItemLocation, EFormType } from '~/const/formReport'

const hasFormInputReported = {
  createAccount: {
    country: false,
    name: false,
    phone: false,
    confirm: false
  }
}

export const onlyFormRouteNames = ['registration-form-region', 'lead-form-sign']

function handlerInputComplete(
  /** @type import('vue/types/vue').Vue */
  vm,
  { data, teaMap, reportFormName, reportSign, params = {} }
) {
  if (data === undefined || data === '' || reportFormName[reportSign]) return

  vm.$commonReport?.(teaMap, params)
  reportFormName[reportSign] = true
}

function reportEvent(
  /** @type import('vue/types/vue').Vue */
  vm,
  { teaMap, params = {} }
) {
  vm.$commonReport?.(teaMap, params)
}


function countryListToI18n(vm = {
  $t: () => {
  }
}, countryList = []) {
  return countryList.map(v => {
    const regionLabelI18n = vm.$t(`region_${v.value}`)
    return {
      value: v.value,
      label: regionLabelI18n !== `region_${v.value}` ? regionLabelI18n : v.label
    }
  })
}

const form_email_message = 'form_email_message'
const form_website_message = 'form_website_message'

export const getFormConfig = (
  type,
  data = {
    formName: 'leaveInfo',
    isFromWechat: false,
    countryList: [],
    timezoneList: [],
    currencyList: [],
    industryList: [],
    advIndustryList: [],
    budgetList: [],
    platformList: [],
    leaveInfo: {}
  },
  vm = {
    $t: () => {
    }
  }
) => {
  const formContentId = vm.$store.state.form.formContentId
  const showCheckIcon = vm.$store.state.form.showCheckIcon
  const adv_form = EFormType.adv_form

  const formConfig = {
    registerInfo: {
      items: [
        {
          key: 'country',
          label: vm.$t('form_country_label'),
          component: 'form-item-select',
          editController: true,
          rules: [
            {
              required: true,
              message: vm.$t('form_register_cant_be_empty'),
              trigger: 'blur'
            }
          ],
          props: {
            options: countryListToI18n(vm, data.countryList),
            optionKeyConfig: {
              // label: 'text'
            },
            selectProps: {
              placeholder: vm.$t('form_country_placeholder'),
              filterable: true,
              'no-match-text': vm.$t('form_no_item_matched')
            }
          },
          on: {
            change(data, lastData = '') {
              vm.$commonReport(vm.$TeaMap.link_tt_tt4b_register_form_item_change, {
                module_name: adv_form,
                content_id: formContentId,
                form_type: adv_form,
                type: 'country'
              })
              handlerInputComplete(vm, {
                data,
                teaMap: TeaMap.register_account_country_edit_complete,
                reportFormName: hasFormInputReported.createAccount,
                reportSign: 'country',
                params: {
                  from_country: lastData,
                  to_country: data
                }
              })
            }
          },
          location: EFormItemLocation.country_or_region,
          isFold: true
        },
        {
          key: 'second_industry',
          component: 'form-item-tree',
          label: vm.$t('form_leaveinfo_industry_label'),
          rules: [
            {
              required: true,
              validator(rule, value, callback) {
                if (value === null || value === undefined) {
                  vm.$commonReport(vm.$TeaMap.link_tt_tt4b_register_form_item_blur, {
                    module_name: adv_form,
                    content_id: formContentId,
                    form_type: adv_form,
                    type: 'industry',
                    status: 'empty'
                  })
                  return callback(new Error(vm.$t('adv_validate_industry')))
                }
                vm.$commonReport(vm.$TeaMap.link_tt_tt4b_register_form_item_change, {
                  module_name: adv_form,
                  content_id: formContentId,
                  form_type: adv_form,
                  type: 'industry'
                })
                callback()
              },
              trigger: 'change'
            }
          ],
          style: {
            // width: '330px'
          },
          props: {
            options: data.advIndustryList
          },
          location: EFormItemLocation.industry
        },
        {
          key: 'company',
          label: vm.$t('form_business_name_label'),
          component: 'vi-input',
          showTips(data) {
            const map = {
              AE: 'module_self_ae_company_hint',
              SA: 'self_ac_sa_company_info'
            }
            return {
              show: ['AE', 'SA'].includes(data.country),
              message: map[data.country] || ''
            }
          },
          showIcon(data) {
            return showCheckIcon && data.company
          },
          rules: [
            {
              required: true,
              validator(rule, value, callback) {
                if (value === null || value === undefined) {
                  vm.$commonReport(vm.$TeaMap.link_tt_tt4b_register_form_item_blur, {
                    module_name: adv_form,
                    content_id: formContentId,
                    form_type: adv_form,
                    type: 'business_name',
                    status: 'empty'
                  })
                  return callback(new Error(vm.$t('form_register_cant_be_empty')))
                }
                vm.$commonReport(vm.$TeaMap.link_tt_tt4b_register_form_item_change, {
                  module_name: adv_form,
                  content_id: formContentId,
                  form_type: adv_form,
                  type: 'business_name'
                })
                vm.$commonReport(vm.$TeaMap.link_tt_tt4b_register_form_item_blur, {
                  module_name: adv_form,
                  content_id: formContentId,
                  form_type: adv_form,
                  type: 'business_name',
                  status: 'success'
                })
                callback()
              },
              trigger: 'blur'
            }
          ],
          props: {
            placeholder: vm.$t('form_register_business_name_placeholder')
          },
          on: {
            blur(data) {
              handlerInputComplete(vm, {
                data,
                teaMap: TeaMap.register_account_name_complete,
                reportFormName: hasFormInputReported.createAccount,
                reportSign: 'name'
              })
            }
          },
          location: EFormItemLocation.business_name
        },
        {
          key: 'timezone',
          label: vm.$t('form_timezone_label'),
          component: 'form-item-select',
          rules: [
            {
              required: true,
              message: vm.$t('form_register_cant_be_empty'),
              trigger: 'change'
            }
          ],
          on: {
            change(data, lastData = '') {
              vm.$commonReport(vm.$TeaMap.link_tt_tt4b_register_form_item_change, {
                module_name: adv_form,
                content_id: formContentId,
                form_type: adv_form,
                type: 'timezone'
              })
            }
          },
          style: {},
          props: {
            options: data.timezoneList,
            optionKeyConfig: {
              value: 'timezone',
              key: 'key'
            },
            selectProps: {
              placeholder: vm.$t('form_register_timezone_placeholder'),
              filterable: true,
              'no-match-text': vm.$t('form_no_item_matched')
            }
          },
          location: EFormItemLocation.time_zone,
          isFold: true
        },
        {
          key: 'currency',
          label: vm.$t('form_currency_label'),
          component: 'form-item-select',
          rules: [
            {
              required: true,
              validator(rule, value, callback) {
                if (value === null || value === undefined) {
                  return callback(new Error(vm.$t('form_register_cant_be_empty')))
                }
                callback()
              },
              trigger: 'change'
            }
          ],
          on: {
            blur(data) {
              vm.$commonReport(vm.$TeaMap.link_tt_tt4b_register_form_item_change, {
                module_name: adv_form,
                content_id: formContentId,
                form_type: adv_form,
                type: 'currency'
              })
            }
          },
          style: {},
          props: {
            options: data.currencyList,
            optionKeyConfig: {
              value: 'id',
              key: 'currency',
              label: 'currency'
            },
            selectProps: {
              placeholder: vm.$t('form_register_currency_placeholder'),
              value: 'VND',
              'no-match-text': vm.$t('form_no_item_matched')
            }
          },
          location: EFormItemLocation.currency,
          isFold: true
        },
        {
          key: 'phonenumber',
          label: vm.$t('input_title_mobile'),
          component: 'form-item-phone',
          rules: [
            {
              required: true,
              message: ' ',
              trigger: 'blur'
            }
          ],
          style: {},
          props: {
            placeholder: vm.$t('form_register_phone_placeholder')
          },
          tooltip: vm.$t('form_register_phone_hint'),
          on: {
            blur(data) {
              handlerInputComplete(vm, {
                data,
                teaMap: TeaMap.register_phone_complete,
                reportFormName: hasFormInputReported.createAccount,
                reportSign: 'phone',
                params: {
                  form_type: 'create_adv'
                }
              })
            }
          },
          location: EFormItemLocation.phone
        },
        {
          key: 'email',
          component: 'vi-input',
          label: vm.$t('form_leaveinfo_email_label'),
          rules: [
            {
              required: true,
              validator(rule, value, callback) {
                if (!value) {
                  return callback(new Error(vm.$t('adv_validate_email')))
                }
                validateEmail(value)
                  ? callback()
                  : callback(new Error(vm.$t('form_check_email_hint')))
              },
              trigger: ['blur']
            }
          ],
          style: {},
          tooltip: vm.$t('form_register_email_hint'),
          props: {
            placeholder: vm.$t('adv_validate_email')
          },
          location: EFormItemLocation.email,
          showIcon(data) {
            return showCheckIcon && data.email && validateEmail(data.email)
          }
        },
        {
          key: 'web_url',
          component: 'vi-input',
          label: vm.$t('form_website_label'),
          rules:
             [
              {
                validator: (rule, value, callback) => {
                  if (!value || typeof value === 'string' && IsURL(value) || value.trim() === '') {
                    return callback()
                  }
                  return callback(new Error())
                },
                message: vm.$t(form_website_message),
                trigger: 'blur'
              }
            ],
          props: {
            placeholder: vm.$t('form_website_placeholder')
          },
          location: EFormItemLocation.website
        },
        {
          key: 'promotion_code',
          component: 'form-item-text',
          label: vm.$t('form_promotion_code_label'),
          isHide: false,
          rules: [],
          style: {},
          props: {
            placeholder: vm.$t('form_promotion_code_placeholder')
          },
          location: EFormItemLocation.promotion_code
        },
        {
          key: 'confirm',
          component: 'form-item-checkterm',
          rules: [
            {
              validator(rule, checked, callback) {
                if (!checked) {
                  vm.$commonReport(vm.$TeaMap.link_tt_tt4b_register_form_item_blur, {
                    module_name: adv_form,
                    content_id: formContentId,
                    form_type: adv_form,
                    type: 'protocol_check',
                    status: 'empty'
                  })
                  return callback(new Error(vm.$t('form_check_terms_hint')))
                }
                vm.$commonReport(vm.$TeaMap.link_tt_tt4b_register_form_item_change, {
                  module_name: adv_form,
                  content_id: formContentId,
                  form_type: adv_form,
                  type: 'protocol_check'
                })
                callback()
              },
              trigger: 'change'
            }
          ],
          style: {
            flex: 'unset',
            width: '100%',
            padding: 0
          },
          props: {},
          on: {
            change(data) {
              handlerInputComplete(vm, {
                data,
                teaMap: TeaMap.register_step2_term_check_complete,
                reportFormName: hasFormInputReported.createAccount,
                reportSign: 'confirm'
              })
            }
          },
          location: EFormItemLocation.advertising_term
        },
        {
          key: 'email_term',
          component: 'form-item-emailterm',
          rules: [],
          style: {
            flex: 'unset',
            width: '100%',
            padding: 0
          },
          props: {},
          on: {
            change(data) {
              handlerInputComplete(vm, {
                data,
                teaMap: TeaMap.register_step2_email_term_check_complete,
                reportFormName: hasFormInputReported.createAccount,
                reportSign: 'email_term'
              })
            }
          },
          location: EFormItemLocation.email_notice_term
        }
      ]
    },
    leadFormInfo: {
      items: [
        {
          key: 'company',
          component: 'vi-input',
          label: vm.$t('form_leaveinfo_company_label'),
          rules: [
            {
              required: true,
              message: vm.$t('adv_validate_company'),
              trigger: 'blur'
            }
          ],
          style: {
            // width: '280px',
            // float: 'left'
          },
          props: {
            placeholder: vm.$t('adv_validate_company')
          },
          location: EFormItemLocation.business_name
        },
        {
          key: 'country',
          label: vm.$t('form_lead_country_region_label'),
          component: 'form-item-select',
          rules: [
            {
              required: true,
              message: vm.$t('adv_validate_country_region'),
              trigger: 'blur'
            }
          ],
          props: {
            options: countryListToI18n(vm, data.countryList),
            optionKeyConfig: {
              // label: 'text'
            },
            selectProps: {
              placeholder: vm.$t('form_register_phonecode_select'),
              filterable: true,
              'no-match-text': vm.$t('form_no_item_matched')
            }
          },
          location: EFormItemLocation.country_or_region
        },
        {
          key: 'is_agency',
          label: vm.$t('form_lead_agency_label'),
          component: 'form-item-select',
          rules: [
            {
              required: true,
              message: vm.$t('adv_validate_yes_no'),
              trigger: 'change'
            }
          ],
          style: {},
          props: {
            options: data.agencyList,
            placeholder: vm.$t('form_register_phonecode_select'),
            selectProps: {
              placeholder: vm.$t('form_register_phonecode_select')
            }
          },
          location: EFormItemLocation.is_agency
        },
        {
          key: 'name',
          component: 'vi-input',
          label: vm.$t('form_leaveinfo_name_label'),
          rules: [
            {
              required: true,
              message: vm.$t('adv_validate_name'),
              trigger: 'blur'
            }
          ],
          style: {},
          props: {
            placeholder: vm.$t('adv_validate_name')
          },
          location: EFormItemLocation.name
        },
        {
          key: 'email',
          component: 'vi-input',
          label: vm.$t('form_leaveinfo_email_label'),
          rules: [
            {
              required: true,
              validator(rule, value, callback) {
                if (!value) {
                  return callback(new Error(vm.$t('adv_validate_email')))
                }
                validateEmail(value)
                  ? callback()
                  : callback(new Error(vm.$t('form_check_email_hint')))
              },
              trigger: ['blur']
            },
            {
              validator: (rule, value, callback) => {
                if (
                  typeof value === 'string' &&
                  /@(gmail|hotmail|yahoo)\./.test(value)
                ) {
                  return callback(new Error())
                }
                return callback()
              },
              message: vm.$t(form_email_message),
              trigger: 'blur'
            }
          ],
          style: {},
          props: {
            placeholder: vm.$t('adv_validate_email')
          },
          location: EFormItemLocation.email,
          /* 简化模式下仍然展示 */
          shownInSimplifiedMode: true
        },
        {
          key: 'industry',
          component: 'form-item-select',
          label: vm.$t('form_leaveinfo_industry_label'),
          rules: [
            {
              required: true,
              message: vm.$t('adv_validate_industry'),
              trigger: 'change'
            }
          ],
          style: {
            // width: '330px'
          },
          props: {
            options: data.industryList,
            selectProps: {
              placeholder: vm.$t('form_register_phonecode_select'),
              filterable: true,
              'no-match-text': vm.$t('form_no_item_matched')
            }
          },
          location: EFormItemLocation.industry
        },
        {
          key: 'phonenumber',
          label: vm.$t('input_title_mobile'),
          component: 'form-item-phone',
          rules: [
            {
              required: true,
              message: ' ',
              trigger: 'blur'
            }
          ],
          props: {
            placeholder: vm.$t('form_leaveinfo_phone_label'),
            formName: data.formName
          },
          location: EFormItemLocation.phone
        },
        {
          key: 'budget',
          component: 'form-item-select',
          label: vm.$t('form_budget_label'),
          rules: [
            {
              required: true,
              message: vm.$t('adv_validate_budget'),
              trigger: 'change'
            }
          ],
          props: {
            options: data.budgetList,
            selectProps: {
              placeholder: vm.$t('form_register_phonecode_select'),
              filterable: true,
              'no-match-text': vm.$t('form_no_item_matched')
            }
          },
          on: {
            change(val) {
              const dataStr = data.budgetList?.find(item => item.value === val)
                ?.desc
              const reportVal = dataStr.startsWith('>')
                ? 200000
                : Number(dataStr?.match(/\d+$/g)?.[0] || 0)
              customReportTTPixel({
                id: 'C2VH3V0HEMJVRV99ML30',
                type: 'Purchase',
                params: {
                  value: reportVal
                }
              })
            }
          },
          location: EFormItemLocation.budget
        },
        {
          key: 'website',
          component: 'vi-input',
          label: vm.$t('form_website_label'),
          rules: data.isFromWechat
            ? [
              {
                validator: (rule, value, callback) => {
                  if (!value) return callback()
                  if (typeof value === 'string' && IsURL(value)) {
                    return callback()
                  }
                  return callback(new Error())
                },
                message: vm.$t(form_website_message),
                trigger: 'blur'
              }
            ]
            : [
              {
                required: true,
                // message,
                trigger: 'blur',
                message: vm.$t(form_website_message)
              },
              {
                validator: (rule, value, callback) => {
                  if (typeof value === 'string' && IsURL(value)) {
                    return callback()
                  }
                  return callback(new Error())
                },
                message: vm.$t(form_website_message),
                trigger: 'blur'
              }
            ],
          style: {
            // width: '280px',
            // float: 'left'
          },
          props: {
            placeholder: vm.$t('form_website_placeholder')
          },
          location: EFormItemLocation.website
        },
        {
          key: 'title',
          component: 'form-item-select',
          label: vm.$t('form_title_label'),
          isHide: true,
          rules: [
            {
              required: true,
              // message,
              trigger: 'blur',
              message: vm.$t('form_title_message')
            }
          ],
          props: {
            options: data.title,
            selectProps: {
              placeholder: vm.$t('form_register_phonecode_select'),
              filterable: true,
              'no-match-text': vm.$t('form_no_item_matched')
            }
          }
        },
        {
          key: 'marketing_destination',
          component: 'form-item-select',
          label: vm.$t('form_marketing_destination_label'),
          isHide: true,
          rules: [
            {
              required: true,
              // message,
              trigger: 'blur',
              message: vm.$t('form_marketing_destination_message')
            }
          ],
          props: {
            options: data.marketingDestination,
            selectProps: {
              placeholder: vm.$t('form_register_phonecode_select'),
              filterable: true,
              'no-match-text': vm.$t('form_no_item_matched')
            }
          }
        },
        {
          key: 'business_role',
          component: 'form-item-select',
          label: vm.$t('form_business_role_label'),
          isHide: true,
          rules: [
            {
              required: true,
              // message,
              trigger: 'blur',
              message: vm.$t('form_business_role_message')
            }
          ],
          props: {
            options: data.businessRole,
            selectProps: {
              placeholder: vm.$t('form_register_phonecode_select'),
              filterable: true,
              'no-match-text': vm.$t('form_no_item_matched')
            }
          }
        },
        {
          key: 'consider_tiktok_ads',
          component: 'form-item-select',
          label: vm.$t('form_consider_tiktok_ads_label'),
          isHide: true,
          rules: [
            {
              required: true,
              // message,
              trigger: 'blur',
              message: vm.$t('form_consider_tiktok_ads_message')
            }
          ],
          props: {
            options: data.considerTiktokAds,
            selectProps: {
              placeholder: vm.$t('form_register_phonecode_select'),
              filterable: true,
              'no-match-text': vm.$t('form_no_item_matched')
            }
          }
        },
        {
          key: 'marketing_objective',
          component: 'form-item-select',
          label: vm.$t('form_marketing_objective_label'),
          isHide: true,
          rules: [
            {
              required: true,
              // message,
              trigger: 'blur',
              message: vm.$t('form_marketing_objective_message')
            }
          ],
          props: {
            options: data.marketingObjective,
            selectProps: {
              placeholder: vm.$t('form_register_phonecode_select'),
              multiple: true,
              'multiple-limit': 3,
              'no-match-text': vm.$t('form_no_item_matched')
            }
          }
        },
        {
          key: 'competitor_platform_used',
          component: 'form-item-select',
          label: vm.$t('form_competitor_platform_label'),
          rules: [
            {
              required: true,
              message: vm.$t('adv_validate_budget_platform_used'),
              trigger: 'blur'
            }
          ],
          props: {
            options: data.platformList,
            selectProps: {
              multiple: true,
              placeholder: vm.$t('form_competitor_platform_placeholder'),
              'no-match-text': vm.$t('form_competitor_platform_no_ad')
            }
          },
          location: EFormItemLocation.competitor_platform_used
        },
        {
          key: 'confirm',
          component: 'form-item-agreeterm',
          rules: [],
          style: {
            width: '100%',
            'max-width': 'unset',
            'margin-bottom': 0,
            padding: 0,
            flex: 'unset'
          },
          props: {
            canadaDifferentTerm: true,
            formName: data.formName
          },
          location: EFormItemLocation.user_term,
          /* 简化模式下仍然展示 */
          shownInSimplifiedMode: true

        }
      ]
    },
    agencyLead: {
      items: [
        {
          key: 'monthly_budget',
          component: 'form-item-select',
          label: vm.$t('agency_monthly_budget_question'),
          rules: [
            {
              required: true,
              message: vm.$t('form_register_cant_be_empty')
            }
          ],
          props: {
            options: data.monthlyBudget,
            selectProps: {
              placeholder: vm.$t('form_register_phonecode_select'),
              filterable: true,
              'no-match-text': vm.$t('form_no_item_matched')
            }
          }
        },
        {
          key: 'consider_tiktok_ads',
          component: 'form-item-select',
          label: vm.$t('agency_first_time_question'),
          rules: [
            {
              required: true,
              message: vm.$t('form_register_cant_be_empty')
            }
          ],
          props: {
            options: data.yesOrNo,
            selectProps: {
              placeholder: vm.$t('form_register_phonecode_select'),
              filterable: true,
              'no-match-text': vm.$t('form_no_item_matched')
            }
          }
        },
        {
          key: 'full_name',
          component: 'form-item-select',
          label: vm.$t('agency_when_ads_question'),
          rules: [
            {
              required: true,
              message: vm.$t('form_register_cant_be_empty')
            }
          ],
          props: {
            options: data.whenAds,
            selectProps: {
              placeholder: vm.$t('form_register_phonecode_select'),
              filterable: true,
              'no-match-text': vm.$t('form_no_item_matched')
            }
          }
        },
        {
          key: 'business_name',
          component: 'vi-input',
          label: vm.$t('agency_brand_question'),
          rules: [
            {
              required: true,
              validator(rule, value, callback) {
                if (!value) {
                  return callback(new Error(vm.$t('form_register_cant_be_empty')))
                }
              },
              trigger: ['blur']
            }
          ],
          props: {
            placeholder: vm.$t('agency_brand_placeholder')
          },
          /* 简化模式下仍然展示 */
          shownInSimplifiedMode: true
        },
        {
          key: 'purpose',
          component: 'vi-input',
          label: vm.$t('agency_kpi_question'),
          rules: [
            {
              required: true,
              validator(rule, value, callback) {
                if (!value) {
                  return callback(new Error(vm.$t('form_register_cant_be_empty')))
                }
              },
              trigger: ['blur']
            }
          ],
          props: {
            placeholder: vm.$t('agency_kpi_placeholder')
          },
          /* 简化模式下仍然展示 */
          shownInSimplifiedMode: true
        },
        {
          key: 'website',
          component: 'vi-input',
          label: vm.$t('agency_website_question'),
          rules: [
            {
              validator: (rule, value, callback) => !value || validateUrl(value)
                ? callback()
                : callback(new Error('Invalid URL')),
              trigger: ['blur']
            }
          ],
          location: EFormItemLocation.website,
          /* 简化模式下仍然展示 */
          shownInSimplifiedMode: true
        },
        {
          key: 'ok_to_contact',
          component: 'form-item-select',
          label: vm.$t('agency_creative_production_question'),
          rules: [
            {
              required: true,
              message: vm.$t('form_register_cant_be_empty')
            }
          ],
          props: {
            options: data.yesOrNo,
            selectProps: {
              placeholder: vm.$t('form_register_phonecode_select'),
              filterable: true,
              'no-match-text': vm.$t('form_no_item_matched')
            }
          }
        },
        {
          key: 'if_agency',
          component: 'form-item-select',
          label: vm.$t('agency_other_partner_question'),
          rules: [
            {
              required: true,
              message: vm.$t('form_register_cant_be_empty')
            }
          ],
          props: {
            options: data.yesOrNo,
            selectProps: {
              placeholder: vm.$t('form_register_phonecode_select'),
              filterable: true,
              'no-match-text': vm.$t('form_no_item_matched')
            }
          }
        },
        {
          key: 'competitor_platform_used',
          component: 'form-item-select',
          label: vm.$t('agency_current_ads_question'),
          rules: [
            {
              validator: (rule, value, callback) => value?.length >= 0
                ? callback()
                : callback(new Error('Invalid')),
              trigger: ['blur']
            }
          ],
          props: {
            options: data.competitorsUsed,
            selectProps: {
              placeholder: vm.$t('form_register_phonecode_select'),
              multiple: true,
              'no-match-text': vm.$t('form_no_item_matched')
            }
          }
        }
      ]
    }
  }

  return formConfig[type]
}

export const validateLeadForm = (valid, rules, vm) => {
  /**
   * 表单校验结果
   */
  // valid为true则通过
  if (!valid) {
    // valid为false的情况
    if (Object.keys(rules).length === 1) {
      // 如果不通过的规则中 只存在email且不符合email指定的规则message 或 只存在website且不符合website指定的规则message 则通过
      if (
        rules.email?.[0]?.message === vm.$t(form_email_message) ||
        rules.website?.[0]?.message === vm.$t(form_website_message)
      ) {
        return true
      }
    }
    if (Object.keys(rules).length === 2) {
      // 如果不通过的规则中 只 存在email且不符合email指定的规则message与存在website且不符合website指定的规则message 则通过
      if (
        rules.email?.[0]?.message === vm.$t(form_email_message) &&
        rules.website?.[0]?.message === vm.$t(form_website_message)
      ) {
        return true
      }
    }
    return false
  }
  return true
}

function IsURL(str_url = '') {
  const strRegex = /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/
  return strRegex.test(str_url.toLowerCase())
}
